module.exports = __webpack_public_path__ + "static/media/Fathers-day-3.513b4cce.jpg";